export const RUN_IN_MOCK_MODE =
  process.env.REACT_APP_RUN_IN_MOCK_MODE === 'true';
